module.exports = __webpack_public_path__ + "img/MAC1100&1110&1120.0113975d.png";